import { ON_ACCEPT_BULK_IMAGE_REPLACEMENT } from '../../../actions/banners-edit/banner-text-image';
import {
    BannersEditMassActions,
    CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR,
    ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED,
    OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionImageReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case ON_ACCEPT_BULK_IMAGE_REPLACEMENT:
        case CLOSE_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;

        case OPEN_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        imageBulkReplacementEditorVisible: true
                    }
                }
            };
        }

        case ON_MASS_ACTIONS_BULK_IMAGE_REPLACEMENT_EDITOR_TOGGLE_CHANGED: {
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        replaceOrDeleteToggle: action.toggleValue
                    }
                }
            };
        }

        default:
            return state;
    }
}
